import {
  BjccLogo,
  CajundomeLogo,
    EdlenLogo,
    EdlenLogoDEV,
    EdlenLogoTEST,
    EdlenLogoTRAIN,
  EdlenWhiteLogo,
} from 'assets/images';

// set up each log (src & alt)
const BJCC = {
  src: BjccLogo,
  alt: 'BJCC Logo',
};
const CAJUNDOME = {
  src: CajundomeLogo,
  alt: 'Cajundome Logo',
};
const EDLEN = {
  src: EdlenLogo,
  alt: 'Edlen Logo',
};
const EDLEN_DEV = {
    src: EdlenLogoDEV,
    alt: 'Edlen Logo'
};
const EDLEN_TEST = {
    src: EdlenLogoTEST,
    alt: 'Edlen Logo'
};
const EDLEN_TRAIN = {
    src: EdlenLogoTRAIN,
    alt: 'Edlen Logo'
};
const EDLEN_WHITE = {
  src: EdlenWhiteLogo,
  alt: 'Edlen Logo',
};

// set up aliases in config
const LOGO = {
  BJCC,
  bjcc: BJCC,
  Cajun: CAJUNDOME,
  cajundome: CAJUNDOME,
  Edlen: EDLEN,
  edlen: EDLEN,
  edlenWhite: EDLEN_WHITE,
  EdlenDev: EDLEN_DEV,
  edlenDev: EDLEN_DEV,
  edlenTest: EDLEN_TEST,
  edlenTraining: EDLEN_TRAIN,
};

export default LOGO;
